import { beLinkHttp } from '@be-link/http';

import {
  IDomainUsedResponse,
  IGetAddressListRequest,
  IGetWebAuthUserInfoRequest,
  IGetWebAuthUserInfoResponse,
  ISetDefaultAddressRequest,
  IUserCheckAuthRequiredRequest,
  IUserCheckAuthRequiredResponse,
  IUserDetailResult,
  IUserLiveCanShareLiveRequest,
  IUserLiveCanShareLiveResponse,
  IUserLiveRoomTokenRequest,
  IUserLiveRoomTokenResponse,
  IUserLoginRequest,
  IUserLoginResponse,
  IUpdateLoginRequest,
  IUpdateLoginResponse,
  UserAddressDTO,
  ICheckAndGetWelfareOfficialResponse,
  ICheckUserRoomAccessRequest,
  ICheckUserRoomAccessResponse,
  IGetUserLiveRoomInfoRequest,
  IGetUserLiveRoomInfoResponse,
  IGetStoreDetailResponse,
  IIsNewCustomerLiveRoomRequest,
  IIsNewCustomerLiveRoomResponse,
  IInspectAndGetWelfareOfficialRequest,
  IInspectAndGetWelfareOfficialResponse,
} from '@/api/user/types';

/** 获取域名 */
export const fetchDomainUsed = () => {
  return beLinkHttp.post<IDomainUsedResponse>('/domain/used', {});
};

/** 是否可以分享 */
export const fetchUserLiveCanShareLive = (data: IUserLiveCanShareLiveRequest) => {
  return beLinkHttp.post<IUserLiveCanShareLiveResponse>('/api/user/live/can-share-live', data);
};

/**
 * 获取用户详情
 * @param userId 用户ID
 * @returns
 */
export async function getUserDetail(userId: string) {
  return beLinkHttp.post<IUserDetailResult>(`/api/user/info/get-user-detail`, { userId });
}

/**
 * 绑定门店
 */
export async function bindStore(storeId: string) {
  return beLinkHttp.post<boolean>(`/api/user/info/bind-store`, { storeId });
}

/**
 * 校验是否需要做微信授权认证
 */
export const checkAuthRequired = (data: IUserCheckAuthRequiredRequest) => {
  return beLinkHttp.post<IUserCheckAuthRequiredResponse>('/api/user/info/check-auth-required', data);
};

/**
 * 用户登录（注册+登录）
 */
export const fetchUserLogin = (data: IUserLoginRequest) => {
  return beLinkHttp.post<IUserLoginResponse>('/api/user/info/login', data, { timeout: 15000 });
};

/**
 * 更新微信授权登录信息（快照/存量用户补全）
 */
export const fetchUpdateLogin = (data: IUpdateLoginRequest) => {
  return beLinkHttp.post<IUpdateLoginResponse>('/api/user/info/refresh-wechat-user-info', data, { timeout: 15000 });
};

/**
 * 获取用户直播间Token
 */
export const fetchUserLiveRoomToken = (data: IUserLiveRoomTokenRequest) => {
  return beLinkHttp.post<IUserLiveRoomTokenResponse>('/api/user/live/get-live-room-token', data, { timeout: 15000 });
};

/**
 * 获取用户地址列表
 */
export function getUserAddressList(data: IGetAddressListRequest) {
  return beLinkHttp.post<UserAddressDTO[]>(`/api/user/address/get-address-list`, data);
}

/**
 * 设置默认用户地址列表
 */
export function setUserDefaultAddress(data: ISetDefaultAddressRequest) {
  return beLinkHttp.post<UserAddressDTO>(`/api/user/address/set-default-address`, data);
}

/**
 * 获取微信用户信息
 */
export function getWebAuthUserInfo(data: IGetWebAuthUserInfoRequest) {
  return beLinkHttp.post<IGetWebAuthUserInfoResponse>(`/api/user/wechat/get-web-auth-user-info`, data);
}

/**
 * 检查并获取福利官信息
 */
export function checkAndGetWelfareOfficial(data: { userId: string; storeId: string }) {
  return beLinkHttp.post<ICheckAndGetWelfareOfficialResponse>(`/welfare/check-and-get-welfare-official`, data);
}

/**
 * 根据微信UnionID获取用户福利官状态及相关信息
 */
export function getIsWelfare(unionId: string) {
  return beLinkHttp.post<{ isWelfare: boolean; pandoraUserId: string }>(`/api/user/info/get-is-welfare`, { unionId });
}

/**
 * 根据用户身份查看能否观看直播/有更好的直播推荐
 */
export const checkUserRoomAccess = (data: ICheckUserRoomAccessRequest) => {
  return beLinkHttp.post<ICheckUserRoomAccessResponse>('/room/check-user-room-access', data, { timeout: 15000 });
};

/**
 * 查询是否新客直播间
 */
export const isNewCustomerLiveRoom = (data: IIsNewCustomerLiveRoomRequest) => {
  return beLinkHttp.post<IIsNewCustomerLiveRoomResponse>('/room/is-new-customer-live-room', data, { timeout: 15000 });
};

/**
 *  查看用户 直播间信息
 */

export const getUserLiveRoomInfo = (data: IGetUserLiveRoomInfoRequest) => {
  return beLinkHttp.post<IGetUserLiveRoomInfoResponse>('/api/user/info/get-user-live-room-info', data, {
    timeout: 15000,
  });
};

/**
 * 查询门店详情
 */
export const getStoreDetail = (storeId: string) => {
  return beLinkHttp.post<IGetStoreDetailResponse>('/store/get-store-detail', { storeId });
};

/**
 * 检查并获取福利官信息
 */
export function inspectAndGetWelfareOfficial(data: IInspectAndGetWelfareOfficialRequest) {
  return beLinkHttp.post<IInspectAndGetWelfareOfficialResponse>('/welfare/inspect-and-get-welfare-official', data);
}
